/* Close through Klaviyo's own control to release its focus trap and scroll lock. */
(() => {
  const selector = '[class*="kl-private-reset-css"][role="dialog"][aria-modal="true"]';
  const closePopups = () => {
    document.querySelectorAll(selector).forEach(dialog => {
      if (dialog.closest('footer, .footer, .klaviyo-form-T5pHYr')) return;
      const close = dialog.querySelector('button[aria-label="Close dialog"]');
      if (close) close.click();
    });
  };
  const observer = new MutationObserver(records => {
    if (records.some(record => record.addedNodes.length)) closePopups();
  });
  observer.observe(document.body, {childList: true, subtree: true});
  closePopups();
})();
